module.exports = __webpack_public_path__ + "assets/img/112.21b62b89.png";